import React from 'react';
import './Compare.scss';
import '../AreaDetail/PopUpInfo.scss';

function ComparePopUpInfo({ setShowInfo, data }) {
  return (
    <div
      className={
        data.category === 'Housing Demand Forecast'
          ? 'popup comparePopup comparePopup--forecast'
          : 'popup comparePopup'
      }
    >
      <div className="popup__content">
        <div
          className="comparePopup__x mobile-only"
          onClick={() => {
            setShowInfo(false);
          }}
        >
          X
        </div>
        <p className="popup__content__title">{data.category} Score Definition</p>
        <p className="popup__content__copy">{data.copy}</p>
        {data.copy2 ? <p className="popup__content__copy">{data.copy2}</p> : <></>}
        {data.copy3 ? <p className="popup__content__copy narBlue">{data.copy3}</p> : <></>}
      </div>
    </div>
  );
}

export default ComparePopUpInfo;
